var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vademecum",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profesionales_Web",
    transform: "translate(-495.000000, -1158.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cuadro-01-Copy",
    transform: "translate(414.000000, 1105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,85 C108.3455,85 107,83.6545 107,82 C107,80.3455 108.3455,79 110,79 C111.6545,79 113,80.3455 113,82 C113,83.6545 111.6545,85 110,85 M87,74 C85.3455,74 84,72.6545 84,71 C84,69.3455 85.3455,68 87,68 C88.6545,68 90,69.3455 90,71 C90,72.6545 88.6545,74 87,74 M110,56 C111.6545,56 113,57.3455 113,59 C113,60.6545 111.6545,62 110,62 C108.3455,62 107,60.6545 107,59 C107,57.3455 108.3455,56 110,56 M110.166667,76.3333333 C108.416667,76.3333333 106.862083,77.12375 105.791667,78.34875 L92.5339583,71.7191667 C92.6185417,71.3239583 92.6666667,70.9185417 92.6666667,70.5 C92.6666667,70.0814583 92.6185417,69.6745833 92.5339583,69.2808333 L105.791667,62.65125 C106.862083,63.87625 108.416667,64.6666667 110.166667,64.6666667 C113.38375,64.6666667 116,62.0504167 116,58.8333333 C116,55.61625 113.38375,53 110.166667,53 C106.949583,53 104.333333,55.61625 104.333333,58.8333333 C104.333333,59.251875 104.381458,59.65875 104.466042,60.0539583 L91.2083333,66.6820833 C90.1379167,65.4570833 88.5833333,64.6666667 86.8333333,64.6666667 C83.61625,64.6666667 81,67.2829167 81,70.5 C81,73.7170833 83.61625,76.3333333 86.8333333,76.3333333 C88.5833333,76.3333333 90.1379167,75.5429167 91.2083333,74.3179167 L104.466042,80.9460417 C104.381458,81.34125 104.333333,81.748125 104.333333,82.1666667 C104.333333,85.38375 106.949583,88 110.166667,88 C113.38375,88 116,85.38375 116,82.1666667 C116,78.9495833 113.38375,76.3333333 110.166667,76.3333333",
    id: "Fill-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLine);
export default __webpack_public_path__ + "static/media/Connect-Line.29aebe4995424e2aaefb9439dff6a177.svg";
export { ForwardRef as ReactComponent };